import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TokenService } from '@services/auth/token.service';
import { SharedService } from '@services/shared/shared.service';
import { DataTableDirective } from 'angular-datatables';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { commonDtOptions, theads } from './table.definition';
import { TitleService } from '@services/title.service';

@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.scss'],
})
export class PurchaseComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  public dtElement: DataTableDirective;
  public searchForm: FormGroup;
  public dtOptions: any = {};
  public dtOptions2: any = {};
  public theads = theads;
  public tableData: object[] = [];
  public filteredData: object[] = [];
  public isFilterMode: boolean = false;
  public noFilterMode: boolean = true;
  public filterPayload: object;
  public timerId: NodeJS.Timeout;
  public eventListener: () => void;

  constructor(
    public toastr: ToastrService,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    private tokenService: TokenService,
    private renderer: Renderer2,
    private sharedService: SharedService,
    private router: Router,
    private titleService: TitleService
  ) {
    this.dtOptions = this.getDtOptions();
    this.dtOptions2 = this.getDtOptions2();
  }

  ngOnInit(): void {
    this.titleService.updateTitle('Purchase Requests');

    this.searchForm = this.formBuilder.group({
      vin_number: [''],
      category: [''],
      status: [''],
      purchase_status: [''],
    });
  }

  ngAfterViewInit(): void {
    this.eventListener = this.renderer.listen('document', 'click', (event) => {
      if (event.target && event.target.closest('.view-btn')) {
        const productId = event.target
          .closest('.view-btn')
          .getAttribute('data-product-id');

        if (productId) {
          this.router.navigate([`/dashboard/purchase-details/${productId}`]);
        }
      }
    });
  }

  ngAfterViewChecked() {
    // This is for to fix the style for show entries
    const parentElement = document.getElementById('purchase-request_length');

    if (parentElement) {
      const labelElement = parentElement.querySelector('label');

      if (labelElement) {
        Object.assign(labelElement.style, {
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        });

        const selectElement = labelElement.querySelector('select');

        if (selectElement) {
          selectElement.style.width = '5rem';
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.eventListener();
  }

  clearField(controlName: string, event: Event) {
    event.stopPropagation();
    this.searchForm.get(controlName).setValue('');
    this.searchProductsFromList({ target: { name: 'Vin_Number', value: '' } } as any);
  }

  searchProductsFromList(event: Event) {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    this.isFilterMode = false;
    this.noFilterMode = false;

    const key = (event.target as HTMLInputElement).name;
    const value = (event.target as HTMLInputElement).value;

    switch (key) {
      case 'Vin_Number':
        this.filterPayload = { [key]: value };

        this.searchForm.get('status').setValue('');
        this.searchForm.get('category').setValue('');

        break;

      case 'type':
        this.filterPayload = { [key]: value };

        this.searchForm.get('status').setValue('');
        this.searchForm.get('vin_number').setValue('');

        break;

      case 'status':
        this.searchForm.get('category').setValue('');
        if (value === 'pending') {
          this.filterPayload = {
            buy_status: 0,
            payment_order_type_status: null,
          };
        } else if (value === 'reserve') {
          this.filterPayload = {
            buy_status: 0,
            payment_order_type_status: true,
          };
        } else if (value === 'unreserve') {
          this.filterPayload = {
            buy_status: 0,
            payment_order_type_status: false,
          };
        } else if (value === 'sold') {
          this.filterPayload = {
            buy_status: true,
            payment_order_type_status: true,
          };
        }

        this.searchForm.get('category').setValue('');
        this.searchForm.get('vin_number').setValue('');
        break;
    }

    this.timerId = setTimeout(
      () => {
        this.isFilterMode = true;
      },
      key === 'Vin_Number' ? 1000 : 500
    );
  }

  getDtOptions() {
    return {
      ...commonDtOptions,
      ajax: (dataTablesParameters: any, callback) => {
        const baseParams = {
          limit: dataTablesParameters.length,
          page: dataTablesParameters.start / dataTablesParameters.length + 1,
        };

        this.http
          .get(environment.v5 + 'payment/list', {
            headers: this.tokenService.getTokenHeader(),
            params: baseParams,
          })
          .subscribe((resp) => {
            this.tableData = this.sharedService.preparePurchaseTableData(
              resp['data']
            );

            callback({
              recordsTotal: resp?.['data']?.[0]?.['total_rows'] || 0,
              recordsFiltered: resp?.['data']?.[0]?.['total_rows'] || 0,
              data: this.tableData,
            });
          });
      },
    };
  }

  getDtOptions2() {
    return {
      ...commonDtOptions,
      ajax: (dataTablesParameters: any, callback) => {
        const baseParams = {
          limit: dataTablesParameters.length,
          page: dataTablesParameters.start / dataTablesParameters.length + 1,
        };

        this.http
          .post(
            environment.newInventoryApi + 'inventory/payment/search',
            this.filterPayload,
            {
              headers: this.tokenService.getTokenHeader(),
              params: baseParams,
            }
          )
          .subscribe((resp) => {
            this.tableData = this.sharedService.preparePurchaseTableData(
              resp['data']
            );

            callback({
              recordsTotal: resp?.['data']?.[0]?.['total_rows'] || 0,
              recordsFiltered: resp?.['data']?.[0]?.['total_rows'] || 0,
              data: this.tableData,
            });
          });
      },
    };
  }

  resetFilter() {
    this.isFilterMode = false;
    this.noFilterMode = true;

    this.searchForm.reset();
    this.searchForm.get('category').setValue('');
    this.searchForm.get('status').setValue('');
  }
}
